import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { useCookies } from 'react-cookie';

// Material UI
import Paper from '@mui/material/Paper';
import Box from '@mui/system/Box';

// Components
import AppBar from 'components/Header/AppBar';
import TopBar from 'components/Header/TopBar';
import TopMenu from 'components/Header/TopMenu/DesktopTopMenu/TopMenu';
import MobileTopMenu from 'components/Header/TopMenu/MobileTopMenu/MobileTopMenu';
import BenefitsTab from 'components/PriceMatch/BenefitsTab';

// Hooks & Utils
import { DEFAULT_COOKIE_OPTIONS } from 'utils/cookies';
import { usePreserveScroll } from 'hooks/usePreserveScroll';

interface HeaderPropsTypes {
  hideTopBar: boolean;
  hideAppBar: boolean;
  hideTopMenu: boolean;
}

const Header = ({ hideTopBar = false, hideAppBar = false, hideTopMenu = false }: HeaderPropsTypes) => {
  const closeIconRef = useRef(null);
  const [showTopMenuDrawer, setShowTopMenuDrawer] = useState(false);
  const { isScrolled } = usePreserveScroll();

  const router = useRouter();
  const [, setCookie] = useCookies(['creoate_retailer_referrer', 'creoate_retailer_is_referred']);
  const { referred, referrer } = router.query;

  useEffect(() => {
    if (referred && referrer) {
      setCookie('creoate_retailer_is_referred', referred, DEFAULT_COOKIE_OPTIONS);
      setCookie('creoate_retailer_referrer', referrer, DEFAULT_COOKIE_OPTIONS);
    }
  }, [referred, referrer, setCookie]);

  const handleTopMenuDrawerToggle = () => {
    setShowTopMenuDrawer(!showTopMenuDrawer);
  };

  const mobileTopMenuCloseHandler = () => {
    setShowTopMenuDrawer(false);
  };

  return (
    <>
      <Box ref={closeIconRef} />
      <Box sx={{ position: 'sticky', top: 0, zIndex: 5 }}>
        <Paper square elevation={0}>
          {!hideTopBar && <TopBar isScrolled={isScrolled} />}

          {/* top menu toggler */}
          {!hideAppBar && <AppBar handleTopMenuDrawerToggle={handleTopMenuDrawerToggle} isScrolled={isScrolled} />}

          {/* top menu */}
          {!hideTopMenu && (
            <>
              <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                <MobileTopMenu
                  showTopMenuDrawer={showTopMenuDrawer}
                  onClose={mobileTopMenuCloseHandler}
                  closeIconRef={closeIconRef}
                />
              </Box>
              <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <TopMenu />
              </Box>
            </>
          )}

          <BenefitsTab isScrolled={isScrolled} />
        </Paper>
      </Box>
    </>
  );
};

export default Header;
